export default "__VITE_ASSET__DfGvupmK__"